import styles from './token.module.css'

// Styles for TokenBox.jsx
const tokenBoxStyle = {
  outer_box: `w-full h-unset rounded-[20px] border-[#FFF] border-2 relative py-[35px] px-[20px] flex flex-col justify-between gap-[15px]
              sm:max-w-[390px]
  `,
  top_right_outer_circle: `w-[94px] h-[94px] flex items-center justify-center absolute bg-darkColor -top-[14.5px] -right-[15.5px] rounded-full border-2 border-r-transparent border-b-transparent rotate-[-90deg]`,
  top_right_inner_circle: `bg-darkColor w-[70px] h-[70px] flex items-center justify-center rounded-full border-2 relative ${styles.buy_token_card_corner_bg}`,
  heading: `pr-[70px] text-[20px] font-[700] leading-[24px] text-white text-stroke
            sm:text-[24px] sm:leading-[32px]
  `,
  description: `text-[14px] font-[400] leading-[20px]
                sm:text-[16px] sm:leading-[24px]
  `,
  top_right_img: `rotate-[90deg] w-[inheirt] h-[inheirt]`
};

// Styles for BuyToken.jsx
const buyTokenStyle = {
  component_wrapper: `flex flex-col items-center gap-12 py-[40px] container
                      sm:py-[50px] sm:gap-20
  `,
  token_card_wrpr: `flex flex-wrap justify-center items-center gap-y-12 items-stretch
                    screen-1200:flex screen-1200:justify-between screen-1200:items-stretch screen-1200:w-full screen-1200:gap-2
                    sm:grid sm:grid-cols-2 sm:gap-10 sm:gap-y-16
  `,
};


export { tokenBoxStyle, buyTokenStyle };
